import { useContext } from 'react'
import { createPortal } from 'react-dom'

import { BirdviewHeaderActionsContainer } from '../../DashboardBirdview.context'

function BirdviewHeaderActionsPortal({ children }) {
  const container = useContext(BirdviewHeaderActionsContainer)

  return container ? createPortal(children, container) : null
}

export default BirdviewHeaderActionsPortal
